/* eslint-disable max-lines */
import React from 'react';
import { useRouteMatch } from 'react-router-dom';
import userTypeMap from 'utils/usersListMap';
import UsersListFilters from './UsersListFilters';
import UsersNavbar from './UsersNavbar';

const UsersListHeader: React.FC = () => {
  const route = useRouteMatch();

  const userType = Object.entries(userTypeMap).find(
    ([k]) => route.path.split('/').pop() === k
  )?.[1];

  if (!userType) return null;

  return (
    <header className="flex flex-col gap-2">
      <div className="w-full flex flex-row gap-4 justify-between">
        <h2 className="title w-22 flex-shrink-0">Users</h2>
        {React.createElement(userType.headerButtons)}
      </div>

      <UsersNavbar />

      <div className="mt-2">
        <UsersListFilters />
      </div>
    </header>
  );
};

export default UsersListHeader;
